<p-toast [style]="{ marginTop: '80px' }"></p-toast>
<p-confirmDialog
  header="Confirmation"
  icon="pi pi-exclamation-triangle"
></p-confirmDialog>

<p-table
  #pt
  [value]="msgRecipients"
  [lazy]="true"
  (onLazyLoad)="loadLazy($event)"
  dataKey="msgRecipientId"
  selectionMode="single"
  [(selection)]="msgRecipient"
  (onRowSelect)="onRowSelect($event)"
  [loading]="loading"
  [paginator]="showPagination"
  [rows]="25"
  [rowsPerPageOptions]="[25, 100, 200]"
  showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}"
  [totalRecords]="recordTotal"
  sortMode="multiple"
  [multiSortMeta]="multiSortMeta"
  styleClass="p-datatable-striped"
  [ngStyle]="{ width: 'auto' }"
  [resizableColumns]="true"
  [autoLayout]="true"
  [responsive]="true"
  >
  <ng-template pTemplate="caption">
    <div class="d-block text-end justify-content-between align-items-center">
      <h6>Message Recipients</h6>
      <span>
        <!--clear filters-->
        @if (showFilter) {
          <button
            pButton
            pRipple
            class="p-button-text"
          style="
            font-size: 80%;
            padding: 0.643rem 0.75rem !important;
            margin-right: 10px;
          "
            (click)="reloadPage()"
            >
            Clear Filters
          </button>
        }

        <!--add new-->
        @if (!outlineNewButton && showAddRecipient) {
          <button
            pButton
            pRipple
            class="p-button-outlined"
            style="padding: 0.643rem 0.75rem !important"
            (click)="onOpenFormAdd()"
            >
            New MsgRecipient +
          </button>
        }
        @if (showAddRecipient) {
          <button
            pButton
            pRipple
            class="p-button"
            style="padding: 0.643rem 0.75rem !important"
            (click)="onOpenFormAdd()"
            >
            New MsgRecipient +
          </button>
        }
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      @if (msgId) {
        <th [ngStyle]="{ width: 'auto' }">
          <span>Send Mail</span>
        </th>
      }
      @for (col of columns; track col) {
        <th
          [pSortableColumn]="col.field"
          [ngStyle]="{ width: col.width }"
          >
          {{ col.header }}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      }
      <th [ngStyle]="{ width: 'auto' }"></th>
    </tr>
    @if (showFilter) {
      <tr>
        <th>
          <input pInputText type="text" input="pt.filter$event.target.value, 'msgRecipientId', 'in'" style="width:50px;"/>
        </th>
        <th>
          <input pInputText type="text" input="pt.filter$event.target.value, 'firstName', 'in'" style="width:150px;"/>
        </th>
        <th>
          <input pInputText type="text" input="pt.filter$event.target.value, 'lastName', 'in'" style="width:150px;"/>
        </th>
        <th>
          <input pInputText type="text" input="pt.filter$event.target.value, 'email', 'in'" style="width:250px;"/>
        </th>
        <th>
          <input pInputText type="text" input="pt.filter$event.target.value, 'mobileNum', 'in'" style="width:150px;"/>
        </th>
        <th>
          <input pInputText type="text" input="pt.filter$event.target.value, 'mobileCountryCode', 'in'" style="width:50px;"/>
        </th>
        <th>
          <input pInputText type="text" input="pt.filter$event.target.value, 'emailRecipientType', 'in'" style="width:50px;"/>
        </th>
        <th [ngStyle]="{'width': 'auto'}"></th>
        <th [ngStyle]="{'width': 'auto'}"></th>
        <th [ngStyle]="{'width': 'auto'}"></th>
        <th [ngStyle]="{'width': 'auto'}"></th>
        <th [ngStyle]="{'width': 'auto'}"></th>
        <th [ngStyle]="{'width': 'auto'}"></th>
        <th [ngStyle]="{'width': 'auto'}"></th>
        <th [ngStyle]="{'width': 'auto'}"></th>
        <th [ngStyle]="{'width': 'auto'}"></th>
        <th [ngStyle]="{'width': 'auto'}"></th>
        <th [ngStyle]="{'width': 'auto'}"></th>
        <th [ngStyle]="{'width': 'auto'}"></th>
      </tr>
    }
  </ng-template>
  <ng-template pTemplate="body" let-msgRecipient>
    <tr>
      @if (msgId) {
        <td>
          <div class="flex align-items-center">
            <p-checkbox
              name="msgRecipientsEmailList"
              value="{{ msgRecipient.msgRecipientId }}"
              inputId="inputId{{ msgRecipient.msgRecipientId }}"
              (onChange)="checkSelected(msgRecipient.msgRecipientId, $event)"
              [binary]="true"
            ></p-checkbox>
          </div>
        </td>
      }
      <td>{{ msgRecipient.msgRecipientId }}</td>
      <td>{{ msgRecipient.firstName }}</td>
      <td>{{ msgRecipient.lastName }}</td>
      <td>{{ msgRecipient.email }}</td>
      <td>{{ msgRecipient.mobileNum }}</td>
      <td>{{ msgRecipient.mobileCountryCode }}</td>
      <td>{{ msgRecipient.emailRecipientType }}</td>
      <td>{{ msgRecipient.deferredDate | date:'medium' }}</td>
      <td>
        <span class="clickable-count" (click)="showDates(msgRecipient, 'Deferred')">
          {{ msgRecipient.deferredCount }}
        </span>
      </td>
      <td>{{ msgRecipient.bouncedDate| date:'medium' }}</td>
      <td>
        <span class="clickable-count" (click)="showDates(msgRecipient, 'Bounced')">
          {{ msgRecipient.bouncedCount }}
        </span>
      </td>
      <td>{{ msgRecipient.deliveredDate | date:'medium' }}</td>
      <td>{{ msgRecipient.openedDate | date:'medium' }}</td>
      <td>
        <span class="clickable-count" (click)="showDates(msgRecipient, 'Opened')">
          {{ msgRecipient.openedCount }}
        </span>
      </td>
      <td>{{ msgRecipient.clickedDate | date:'medium' }}</td>
      <td>
        <span class="clickable-count" (click)="showDates(msgRecipient, 'Clicked')">
          {{ msgRecipient.clickedCount }}
        </span>
      </td>
      <td>{{ msgRecipient.droppedDate | date:'medium' }}</td>
      <td>{{ msgRecipient.unsubscribedDate | date:'medium' }}</td>
      <td>
        <span style="float: none">
          <a>
            <i
              class="pi pi-pencil"
              aria-hidden="true"
              style="color: blue; font-size: 110%; padding-right: 20px"
              (click)="onOpenFormEdit(msgRecipient)"
            ></i>
          </a>
        </span>
      </td>
    </tr>
  </ng-template>
</p-table>

<p-dialog header="{{ dateType }} Dates" [(visible)]="displayDateDialog" [modal]="true" [style]="{width: '30vw'}">
  @if (dateList.length) {
    <ul>
      @for (date of dateList; track date) {
        <li>{{ date | date: 'medium' }}</li>
      }
    </ul>
  }
  @if (!dateList.length) {
    <p>No {{ dateType.toLowerCase() }} dates available</p>
  }
</p-dialog>